module.exports = __webpack_public_path__ + "static/automation-en-mobile-0463213425a4874bc2300f16c6d75373.png";